/* eslint-disable camelcase */
import { useMutation } from '@tanstack/react-query'
import { ReactQueryKeys } from '@/types'
import { useContext } from 'react'
import { AxiosContext } from '@/context/Axios'

/**
 * Withdraws a connection request the current user sent. There's no dedicated
 * "cancel" endpoint — `connReqUpdate` with status 2 ("reject or delete") is
 * the same call `useConnectionDecline` makes on the recipient side; a
 * connReqID is the same request row regardless of which side calls it.
 */
export const useConnectionCancel = () => {
  const axios = useContext(AxiosContext)
  return useMutation({
    mutationKey: [ReactQueryKeys.CANCEL_CONNECTION],
    mutationFn: async (connReqID: string) => {
      const response = await axios.api.post('ajax/connections', {
        requestType: 'connReqUpdate',
        connReqID: connReqID,
        'cliqueIDs[]': '',
        connReqStatus: 2,
        format: 'json',
      })
      return response.data
    },
  })
}
